<template>
  <div class="twcs-space-y-3">
    <transition
      enter-active-class="twcs-ease-in-out twcs-duration-200"
      enter-from-class="twcs-opacity-0"
      enter-to-class="twcs-opacity-100"
      leave-active-class="twcs-ease-in-out twcs-duration-200"
      leave-from-class="twcs-opacity-100"
      leave-to-class="twcs-opacity-0"
      mode="out-in"
    >
      <div v-if="!filterSearchStore.searchData.resultsLoading">
        <div v-for="(category, index) in filterSearchStore.searchData.results.data" :key="category" class="twcs-flex-1 twcs-min-h-0 twcs-relative twcs-bg-white twcs-pb-1" :id="index.replace(/\s+/g, '-').toLowerCase()">
          <div class="twcs-flex twcs-items-center twcs-px-4 twcs-py-4 sm:twcs-px-6 twcs-border-b-2 twcs-border-kctcs-navy-600">
            <h3 class="twcs-m-0">{{ index }}</h3>
          </div>
          <ul class="twcs-divide-y twcs-divide-gray-200">
            <li v-for="classModel in category" :key="classModel.id" class="">
              <a href="#" @click="onResultSelect(classModel)" class="twcs-block twcs-mx-0.5 sm:twcs-mx-0 focus-visible:twcs-no-underline hover:twcs-bg-gray-100 focus-visible:twcs-bg-gray-100">
                <div v-if="filterSearchStore.showCollegeFilter" class="twcs-text-base twcs-px-8 twcs-pt-4 sm:twcs-px-10">
                  {{ collegeKey[classModel.college] }}
                </div>
                <div
                  :class="[filterSearchStore.showCollegeFilter ? 'twcs-pt-1' : 'twcs-pt-4', 'twcs-flex twcs-items-center twcs-px-4 twcs-pb-4 sm:twcs-px-6']"
                >
                  <div class="twcs-min-w-0 twcs-flex-1 twcs-flex twcs-items-center">
                    <div class="twcs-min-w-0 twcs-flex-1 twcs-px-4 md:twcs-grid md:twcs-grid-cols-2 md:twcs-gap-4">
                      <!-- Show on sm: -->
                      <div class="twcs-block md:twcs-hidden">
                        <p class="twcs-text-base twcs-text-gray-700">
                          {{ classModel.subject }} {{ classModel.catalog_number }} - {{ classModel.title }}
                        </p>
                        <p class="twcs-text-base twcs-text-gray-700">
                          Format: {{ formatKey[classModel.format] }}, Credit Hours: {{ classModel.hours }}
                        </p>
                        <p class="twcs-text-base twcs-text-gray-700">
                          <template v-if="classModel.room !== null">
                            <template v-if="classModel.building_description.indexOf(classModel.room) !== -1">
                              <!-- building_description has room in it -->
                              Location: {{ classModel.building_description }}
                            </template>
                            <template v-else>
                              Location: {{ classModel.building_description }}, Room: {{ classModel.room}}
                            </template>
                          </template>
                          <template v-else-if="classModel.building === 'WWW' || classModel.building === 'WWL'">
                            Location: Online
                          </template>
                          <template v-else>
                            Location: {{ classModel.building }}
                          </template>
                        </p>
                        <p class="twcs-text-base twcs-text-gray-700">
                          Campus: {{ classModel.location }}
                        </p>
                        <p class="twcs-text-base twcs-text-gray-700">
                          Class: {{ classModel.number }}, Section: {{ classModel.section }}
                        </p>
                        <p class="twcs-text-base twcs-text-gray-700">
                          Instructor: {{ classModel.instructor.replace(',', ', ') }}
                        </p>
                        <p class="twcs-text-base twcs-text-gray-700">
                          Enrolled: {{ classModel.enrolled }} of {{ classModel.max_enrollment }}
                        </p>
                      </div>
                      <!-- Show on  > sm: -->
                      <div class="twcs-hidden md:twcs-block">
                        <p class="twcs-text-base twcs-text-gray-700">
                          {{ classModel.subject }} {{ classModel.catalog_number }} - {{ classModel.title }}
                        </p>
                        <p class="twcs-text-base twcs-text-gray-700">
                          Format: {{ formatKey[classModel.format] }}
                        </p>
                        <p class="twcs-text-base twcs-text-gray-700">
                          <template v-if="classModel.room !== null">
                            <template v-if="classModel.building_description.indexOf(classModel.room) !== -1">
                              <!-- building_description has room in it -->
                              Location: {{ classModel.building_description }}
                            </template>
                            <template v-else>
                              Location: {{ classModel.building_description }}, Room: {{ classModel.room}}
                            </template>
                          </template>
                          <template v-else-if="classModel.building === 'WWW' || classModel.building === 'WWL'">
                            Location: Online
                          </template>
                          <template v-else>
                            Location: {{ classModel.building }}
                          </template>
                        </p>
                        <p class="twcs-text-base twcs-text-gray-700">
                          Campus: {{ classModel.location }}
                        </p>
                        <p class="twcs-text-base twcs-text-gray-700">
                          Class: {{ classModel.number }}
                        </p>
                        <p class="twcs-text-base twcs-text-gray-700">
                          Section: {{ classModel.section }}
                        </p>
                        <p class="twcs-text-base twcs-text-gray-700">
                          Credit Hours (max): {{ classModel.hours }}
                        </p>
                      </div>
                      <!-- Show on > md: -->
                      <div class="twcs-hidden md:twcs-block">
                        <p class="twcs-text-base twcs-text-gray-700">
                          Date: <time :datetime="classModel.starts_on">{{ dateFormatedToString(classModel.starts_on) }}</time> - <time :datetime="classModel.ends_on">{{ dateFormatedToString(classModel.ends_on) }}</time>
                        </p>
                        <p class="twcs-text-base twcs-text-gray-700">
                          Days of the Week: {{ classModel.meeting_pattern }}
                        </p>
                        <p class="twcs-text-base twcs-text-gray-700">
                          <template v-if="classModel.begin_time === 'TBA'">
                            Time: {{ classModel.begin_time }}
                          </template>
                          <template v-else>
                            Time: <time :datetime="convertTo24Hr(classModel.begin_time)">{{classModel.begin_time}}</time> - <time :datetime="convertTo24Hr(classModel.end_time)">{{classModel.end_time}}</time>
                          </template>
                        </p>
                        <p class="twcs-text-base twcs-text-gray-700">
                          Instructor: {{ classModel.instructor.replace(',', ', ') }}
                        </p>
                        <p class="twcs-text-base twcs-text-gray-700">
                          Instruction Mode: {{ instructionModeKey[classModel.instruction_mode] }}
                        </p>
                        <p class="twcs-text-base twcs-text-gray-700">
                          Enrolled: {{ classModel.enrolled }} of {{ classModel.max_enrollment }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <!-- Heroicon name: chevron-right -->
                    <svg class="twcs-h-5 twcs-w-5 twcs-text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                    </svg>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </div>
        <div class="twcs-mt-2 sm:twcs-mt-4 sm:twcs-mb-2 twcs-flex twcs-justify-center">
          <Pagination :links="filterSearchStore.searchData.results.links" @pagination-link-clicked="onPaginationClick" />
        </div>
      </div>
      <div v-else class="twcs-p-7 twcs-bg-white">
        <div class="twcs-h-full">
          <div class="twcs-loader-animation twcs-relative twcs-overflow-hidden twcs-bg-gray-150" style="height: 13.5rem;">
            <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-top-2 twcs-bg-white twcs-h-4"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-96 md:twcs-left-3/4 twcs-top-6 twcs-bg-white twcs-h-2"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-top-8 twcs-bg-white twcs-h-4"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-96 md:twcs-left-3/4 twcs-top-12 twcs-bg-white twcs-h-2"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-top-14 twcs-bg-white twcs-h-6"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-bg-white twcs-h-4" style="top: 5.5rem;"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-96 md:twcs-left-3/4 twcs-bg-white twcs-h-2" style="top: 6.5rem;"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-bg-white twcs-h-4" style="top: 7rem;"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-96 md:twcs-left-3/4 twcs-bg-white twcs-h-2" style="top: 8rem;"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-bg-white twcs-h-6" style="top: 8.5rem;"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-bg-white twcs-h-4" style="top: 10.5rem;"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-96 md:twcs-left-3/4 twcs-bg-white twcs-h-2" style="top: 11.5rem;"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-bg-white twcs-h-4" style="top: 12rem;"></div>
            <div class="twcs-absolute twcs-right-0 twcs-left-96 md:twcs-left-3/4 twcs-bg-white twcs-h-2" style="top: 13rem;"></div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import Pagination from '@/components/Pagination.vue';
import { dateFormated, convertTo24HrTime } from '@/helpers/Date.js';
import { useFilterSearchStore } from '@/stores/filter-search.js';
import { formatKey, collegeKey, instructionModeKey } from '@/constants/lookup-keys.js';

let filterSearchStore = useFilterSearchStore();

let emit = defineEmits(['resultSelected']);

function dateFormatedToString(date) {
	return dateFormated(date);
}

function convertTo24Hr(time) {
	return convertTo24HrTime(time);
}

function onPaginationClick(url) {
	let parameters = url.substring(url.indexOf('?') + 1).split('&').map((parameter) => {
		var paramArr = parameter.split('=');
		return { var: paramArr[0], value: paramArr.length > 1 ? paramArr[1] : ""};
	}).filter(param => param.var === "page");
	filterSearchStore.paginate(parameters[0].value);
}

function onResultSelect(classModel) {
	filterSearchStore.setClassModel(classModel);
	emit('resultSelected', classModel);
}
</script>
